import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Chip,
  useMediaQuery,
  useTheme
} from "@mui/material";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React from "react";
import { useNavigate } from "react-router-dom";

const SchemesV2Banner = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Card
      sx={{
        background: "linear-gradient(to right, #d4a76a, #A36E29)",
        color: "white",
        mb: 4,
        borderRadius: 3,
        overflow: "hidden",
        position: "relative"
      }}
    >
      <CardContent sx={{ p: { xs: 3, md: 4 } }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: { xs: "column", md: "row" },
            gap: 3
          }}
        >
          <Box sx={{ flex: 1, textAlign: { xs: "center", md: "left" } }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, justifyContent: { xs: "center", md: "flex-start" } }}>
              <NewReleasesIcon sx={{ fontSize: 28 }} />
              <Chip
                label="NEW"
                size="small"
                sx={{
                  backgroundColor: "#ff4081",
                  color: "white",
                  fontWeight: 600
                }}
              />
            </Box>
            
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                mb: 1,
                fontSize: { xs: "1.8rem", md: "2.2rem" },
                fontFamily: '"Roboto", sans-serif'
              }}
            >
              Enhanced Schemes Experience v2
            </Typography>
            
            <Typography
              variant="body1"
              sx={{
                opacity: 0.9,
                mb: 2,
                fontSize: { xs: "0.9rem", md: "1rem" },
                fontFamily: '"Roboto", sans-serif'
              }}
            >
              Experience our redesigned payment schemes with better tracking, clearer payment schedules, 
              and enhanced user interface. All your favorite schemes with improved functionality!
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: 1,
                flexWrap: "wrap",
                justifyContent: { xs: "center", md: "flex-start" }
              }}
            >
              <Chip
                label="Better UI/UX"
                variant="outlined"
                size="small"
                sx={{ color: "white", borderColor: "rgba(255,255,255,0.5)" }}
              />
              <Chip
                label="Payment Tracking"
                variant="outlined"
                size="small"
                sx={{ color: "white", borderColor: "rgba(255,255,255,0.5)" }}
              />
              <Chip
                label="Mobile Optimized"
                variant="outlined"
                size="small"
                sx={{ color: "white", borderColor: "rgba(255,255,255,0.5)" }}
              />
            </Box>
          </Box>

          <Box sx={{ textAlign: "center" }}>
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate("/schemes-v2")}
              sx={{
                backgroundColor: "white",
                color: "#A36E29",
                fontWeight: 600,
                px: 4,
                py: 1.5,
                fontSize: "1rem",
                borderRadius: 2,
                fontFamily: '"Roboto", sans-serif',
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.9)",
                  transform: "translateY(-2px)"
                },
                transition: "all 0.3s ease"
              }}
            >
              Try Schemes v2
            </Button>
            
            <Typography
              variant="body2"
              sx={{
                mt: 1,
                opacity: 0.8,
                fontSize: "0.8rem",
                fontFamily: '"Roboto", sans-serif'
              }}
            >
              Your current schemes remain accessible
            </Typography>
          </Box>
        </Box>

        {/* Decorative elements */}
        <Box
          sx={{
            position: "absolute",
            top: -20,
            right: -20,
            width: 100,
            height: 100,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.1)",
            opacity: 0.5
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: -30,
            left: -30,
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.1)",
            opacity: 0.3
          }}
        />
      </CardContent>
    </Card>
  );
};

export default SchemesV2Banner;
